import AlertMessage from '../Page/AlertMessage';

export default AlertMessage;
